// zodUtils.ts
import { Timestamp } from "firebase/firestore";
import * as z from "zod";
import { CurrencyCode } from "./util.types";

export const dateToTimestamp = z
  .preprocess(
    (val) => {
      // If they passed a Date, just use it
      if (val instanceof Date) return val;
      // If they passed a string, try parsing it
      if (typeof val === "string") {
        const d = new Date(val);
        return isNaN(d.getTime()) ? val : d;
      }
      // Otherwise fail
      return val;
    },
    // Now require a valid Date
    z.instanceof(Date, { message: "Invalid date format" })
  )
  // Finally, transform the valid Date → Firestore Timestamp
  .transform((date) => Timestamp.fromDate(date));

export const currencyCode = z.enum(["EUR", "KARMA"] as const) satisfies z.ZodType<CurrencyCode>;
